import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Chip, Typography } from '@mui/material'

import { AccountCircle, ArrowDropDown } from '@mui/icons-material'
import { ApplicationState } from '@/state/root.models'
import useDialog from '@/hooks/ui/use-dialog.hook'

import { DialogsEnum } from '@/enums'
import { useStyles } from './style'
import { DialogAccountStatusForm } from '../dialogs'

export function PlayerAvatar() {
  const { t } = useTranslation()
  const { classes } = useStyles()

  const { playerCard } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const { handleDialogAction } = useDialog()

  return (
    <>
      <Box className={classes.avatarContent}>
        <Avatar className="avatar" alt="player_avatar">
          <AccountCircle />
        </Avatar>
        <Box pl={2}>
          <Typography textTransform="capitalize">{`${
            playerCard?.firstName || 'John'
          } ${playerCard?.lastName || 'Smith'}`}</Typography>
          <Typography variant="body2">
            {playerCard?.username || 'john123'}
          </Typography>
          {playerCard?.accountStatus && (
            <Chip
              variant="filled"
              size="small"
              label={t(`labels.${playerCard?.accountStatus}`)}
              className={playerCard?.accountStatus}
              sx={{
                borderRadius: '6px',
                '& svg': {
                  order: 2,
                  color: 'inherit !important',
                  marginLeft: '2px !important',
                  marginRight: '2px !important',
                },
              }}
              icon={<ArrowDropDown />}
              onClick={() => {
                handleDialogAction({
                  open: true,
                  id: DialogsEnum.DIALOG_EDIT_ACCOUNT_STATUS,
                })
              }}
            />
          )}
        </Box>
      </Box>
      <DialogAccountStatusForm />
    </>
  )
}
